import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "@/mixins/util";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            files: [],
            title: '',
            subTitle: '',
            mcName: '',
            koin: 0,
            seq: 0,
            info: '',
            mcIdx: '',
            url: '',
        }
    },
    validators: {
        files: function (value) {

        },
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해 주세요.')
        },
        subTitle: function (value) {
        },
        mcName: function (value) {
            return Validator.value(value)
              .required('진행자명을 입력해 주세요.')
        },
        seq: function (value) {
            return Validator.value(value)
                .required('순서를 입력해 주세요.')
        },
        koin: function (value) {
            return Validator.value(value)
              .required('KOIN을 입력해 주세요.')
        },
        info: function (value) {
            return Validator.value(value)
              .required('수업 정보를 입력해 주세요.')
        },
        url: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if (util.isEmpty(value)) {
                        return
                    } else if (!util.form.VTypes.url(value)) {
                        return '올바른 주소를 입력해 주세요'
                    }
                })
        },
        mcIdx: function (value) {
        },
    },
}
